import {useState, useEffect, useRef} from 'react';
import { useParams } from 'react-router-dom';
import Loading from '../common/Loading';
import { notify, pleaseRefreshError } from '../../Utils/Notificator';
import {useNavigate} from "react-router";
import {startActivitySession} from "../../Utils/TimerUtils";


const InterviewIframe = (props) => {
	const navigate = useNavigate();
	const [ isLoading, setIsLoading ] = useState(false);
	const [ s3Url, setS3Url ] = useState(props.url);
	const [ h5p, setH5P] = useState(false);
	const userDetails = localStorage.getItem('user');
	const { unitId } = useParams();
	console.log(unitId);

	// 1 https://www.erealonline.net/Interview/
	// Testing https://iframeredirect.tiiny.site
	const iframeUrl = 'https://www.erealonline.net/Interview/'
	const iframeUrl2 = localStorage.getItem("i18n")==="it" ? "https://www.erealonline.net/EniBiasFree/COL2-DISABILITA-IT.html" : "https://www.erealonline.net/EniBiasFree/COL2-DISABILITA-EN.html"
	const iframeUrl3 = localStorage.getItem("i18n")==="it" ? "https://www.erealonline.net/EniBiasFree/COL3-DISLESSIA-IT.html" : "https://www.erealonline.net/EniBiasFree/COL3-DISLESSIA-EN.html"
	const iframeUrl4 = localStorage.getItem("i18n")==="it" ? "https://www.erealonline.net/EniBiasFree/COL4-LGBT-IT.html" : "https://www.erealonline.net/EniBiasFree/COL4-LGBT-EN.html"
	const iframeUrl5 = localStorage.getItem("i18n")==="it" ? "https://www.erealonline.net/EniBiasFree/COL5-GENITORIALITA-IT.html" : "https://www.erealonline.net/EniBiasFree/COL5-GENITORIALITA-EN.html"
	const iframeUrl6 = localStorage.getItem("i18n")==="it" ? "https://www.erealonline.net/EniBiasFree/COL6-DOMANDEDAEVITARE-IT.html" : "https://www.erealonline.net/EniBiasFree/COL6-DOMANDEDAEVITARE-EN.html"
	const iframeUrl7 = localStorage.getItem("i18n")==="it" ? "https://www.erealonline.net/EniBiasFree/COL7-DRESSCODE-IT.html" : "https://www.erealonline.net/EniBiasFree/COL7-DRESSCODE-EN.html"

	const iframeRef = useRef(null);

	const iframeLoadingStyle = {
		overflow: isLoading ? 'false' : 'true'
	}

	useEffect(() => {
		const fetchUnitData = async () => {
			try{
					console.log('location',window.location.href.split('/interview/')[0]);
					console.log('posting auth details to iframe');
					let iframes = document.getElementsByTagName('iframe');
					if(iframes.length>0){
						iframes[0].onload = function() {
							var win = iframes[0].contentWindow;
							var obj = {
								parentUrl: window.location.href.split('/interviewgame/').length>0 && window.location.href.split('/interviewgame/')[0],
								unitId: unitId,
								identifier: `${"c"}${unitId.toString().padStart(3, '0')}`, 
								user: JSON.parse(userDetails),
								authToken: localStorage.getItem("authToken"),
								lng: localStorage.getItem("i18n")
							};
							win.postMessage(JSON.stringify({key: 'storage', data: obj}), "*");
							console.log(obj)
							console.log('auth details posted')
						}
					}
			} catch (error) {
				console.error(error);
				notify(pleaseRefreshError);
			}
		};
		fetchUnitData();
	}, []);

	useEffect(() => {
		const iframe = iframeRef.current;
		console.log('iframe ', iframe)
		const editedTestId = 'c00' + unitId
		startActivitySession(editedTestId)
		if (!iframe) {
			return;
		}

		// Listen for changes in the iframe URL
		const handleUrlChange = () => {
			const url = iframe.contentWindow.location.href;

			if (url.includes('redirect')) {
				setIsLoading(true)
				navigate('/')
			}
		};

		iframe.addEventListener('load', handleUrlChange);

		return () => {
			iframe.removeEventListener('load', handleUrlChange);
		};
	}, [iframeRef]);

	return <div>
		{isLoading ? <Loading /> : <div style={{height:'100%'}}>
			<div id="interview-iframe" className={h5p ? "h5p-box" : "lykiocss-unitiframe-iframe"}>
				<iframe ref={iframeRef} style={iframeLoadingStyle} title="interviewgame" src={parseInt(unitId)===1 ? iframeUrl : 
					parseInt(unitId)===2 ? iframeUrl2 : 
					parseInt(unitId)===3 ? iframeUrl3 :
					parseInt(unitId)===4 ? iframeUrl4 :
					parseInt(unitId)===5 ? iframeUrl5 :
					parseInt(unitId)===6 ? iframeUrl6 :
					parseInt(unitId)===7 ? iframeUrl7 :
					" "} />
			</div>
		</div>}
	</div>
};

export default InterviewIframe;
